// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_BId","colBig":"styles_colBig__3npaJ","colSmall":"styles_colSmall__769PZ"};